import { Box, Typography } from '@mui/material';
import { MRT_ColumnDef } from 'mantine-react-table';
import React, { useMemo } from 'react';
import { ExpenseStatsPoint } from '../../../../types/dashboard';
import { formatCurrencyShort } from '../../../../../shared/utils';
import GenericTable from '../../../../shared/GenericTable';
import { dashboardSummaryTableDefaults } from '../../dashboardReportTableConfig';

type ExpenseClaimedReportListProps = {
    points: ExpenseStatsPoint[];
};

type SummaryRow = ExpenseStatsPoint & { id: number };

export default function ExpenseClaimedReportList({
    points,
}: ExpenseClaimedReportListProps) {
    const columns: MRT_ColumnDef<SummaryRow>[] = useMemo(
        () => [
            {
                accessorKey: 'label',
                header: 'Period',
                size: 180,
            },
            {
                accessorKey: 'expenseCount',
                header: 'Claims',
                size: 120,
            },
            {
                accessorKey: 'totalExpenseClaimed',
                header: 'Total Expense Claimed',
                size: 220,
                Cell: ({ cell }) =>
                    formatCurrencyShort(cell.getValue<number>()),
            },
        ],
        [],
    );

    const rows = useMemo(
        () =>
            (points ?? []).map((point, index) => ({
                id: index + 1,
                ...point,
            })),
        [points],
    );

    if (!rows.length) {
        return (
            <Typography sx={{ mt: 4 }} variant='body2'>
                No expense claims found for this selection.
            </Typography>
        );
    }

    return (
        <Box sx={{ width: '100%' }}>
            <GenericTable
                {...dashboardSummaryTableDefaults}
                columns={columns}
                data={rows}
                tableName='Expense Claimed Summary'
            />
        </Box>
    );
}
